/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import { useState, useEffect } from 'react';

const PickerValue = (props: any) => {
    const { datas, handleClick, option } = props;
    const [value, setValue] = useState<string>("");

    useEffect(() => {
        try {
            const values = option.filter((item: any) => item.key === datas)
            const value = values[0].text;
            setValue(value);
        } catch (error) {
        }
        // eslint-disable-next-line
    }, [option])

    return (
        <td style={{ padding: '0px 10px', width: 226,   }}
            onClick={handleClick}
        >
            <a className='text-dark text-hover-primary d-block ' style={{ cursor: 'pointer', fontSize: '13px', fontWeight: 500, color: '#3F4254'}}>
                {value}
            </a>
        </td>
    )
}

export default PickerValue;